module.exports = "/virtual-football-league/img/amblems/left/logos/Lille.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Lille.png
// module id = 2106
// module chunks = 4